var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowPointRightIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon arrow-right-icon",
    viewBox: "0 0 8 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.164 14.709A.815.815 0 00.3 15.83a.763.763 0 001.092-.14l5.444-7.2a.818.818 0 000-.982L1.392.309A.763.763 0 00.3.169.815.815 0 00.164 1.29L5.237 8 .164 14.709z"
  })));
}

export default SvgArrowPointRightIconSv;